import {
  activeVideoData,
  deferredVideoData,
  policeAndFireVideoData,
} from "features/video/videoData";
import { AccentColors } from "theme/palette";

export const ACTIVE_ABS = "Active ABS";
export const DEFERRED_ABS = "Deferred ABS";
export const POLICE_AND_FIRE_ABS = "Police & Fire ABS";
export const WELSH_ACTIVE_ABS = "Welsh Active ABS";

export type Video = {
  id: string;
  title: string;
  variant: string;
  data: any;
  colour: AccentColors;
};

export const Videos: Record<string, Video> = {
  [ACTIVE_ABS]: {
    id: "cmiq1gvnt0001hmqxqxgm0ivs",
    title: ACTIVE_ABS,
    variant: "aaaaaaaaaa",
    data: activeVideoData,
    colour: AccentColors.primary,
  },
  [DEFERRED_ABS]: {
    id: "cmiq1gvnt0001hmqxqxgm0ivs",
    title: DEFERRED_ABS,
    variant: "dddddd000a",
    data: deferredVideoData,
    colour: AccentColors.secondary,
  },
  [POLICE_AND_FIRE_ABS]: {
    id: "cmiq1gvnt0001hmqxqxgm0ivs",
    title: POLICE_AND_FIRE_ABS,
    variant: "ggghggfd0a",
    data: policeAndFireVideoData,
    colour: AccentColors.tertiary,
  },
  [WELSH_ACTIVE_ABS]: {
    id: "cmrjjqg5k0001ocqxknw6ku0r",
    title: WELSH_ACTIVE_ABS,
    variant: "aaaaaaaaaa",
    data: activeVideoData,
    colour: AccentColors.quaternary,
  },
};
